/**
 * Vue Filter - markdown
 */

/**
 * return rendered markdown.
 * @param {string} val String
 */
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import { encodeHTML } from '@/lib/utils'
import tippy from 'tippy.js'
// import 'tippy.js/themes/material.css'
// import 'tippy.js/themes/translucent.css'

const titleInline = {
	name: 'abbr',
	level: 'inline',
	start(src) {
		const match = src.match(/\w+\^\["/)
		return match ? match.index : src.length
	},
	tokenizer(src, tokens) {
		const rule = /^(\w+)\^\["([^"]+)"]/
		const match = rule.exec(src)

		if (match) {
			const [raw, word, tooltip] = match
			return {
				type: 'abbr',
				raw,
				word,
				tooltip,
				tokens: []
			}
		}

		return undefined
	},
	renderer(token) {
		return `<abbr title="${token.tooltip}">${token.word}</abbr>`
	},
}

const dfnWords = {
	name: 'dfn',
	level: 'inline',
	start(src) {
		return src.match(/\[dfn:/)?.index
	},
	tokenizer(src) {
		const match = /^\[dfn:([^\|\]]+)\|([^\]]+)\]/.exec(src)
		if (match) {
			const [raw, dfn, title] = match
			return {
				type: 'dfn',
				raw,
				dfn,
				title,
			}
		}
	},
	renderer(token) {
		let { title, dfn } = token
		title = encodeHTML(title)
		return `<dfn title="${title}">${dfn}</dfn>`
	}
}

const markWords = {
	name: 'mark',
	level: 'inline',
	start(src) {
		return src.match(/\[mark:/)?.index
	},
	tokenizer(src) {
		const match = /^\[mark:([^\|\]]+)\|([^\]]+)\]/.exec(src)
		if (match) {
			const [raw, dfn, title] = match
			return {
				type: 'mark',
				raw,
				dfn,
				title,
			}
		}
	},
	renderer(token) {
		let { title, dfn } = token
		title = encodeHTML(title)
		return `<mark title="Sentencing Pro Citation. ${title}" class="modification">${dfn}</mark>`
	}
}

marked.use({ extensions: [titleInline, dfnWords, markWords] })


export default function markdown(val = ``) {
	const renderer = new marked.Renderer()
	renderer.code = function (code) {
		if (code?.codeBlockStyle == 'indented') {
			return code.raw
		}
		return code
	}
	renderer.link = ({href, title, text}) => `<a fuck="this" target="_blank" href="${href}">${text}</a>`

	DOMPurify.addHook('afterSanitizeAttributes', function (node) {
		if ('target' in node) {
			node.setAttribute('target','_blank')
			node.setAttribute('rel','noopener')
		}
	})
	const markdown = DOMPurify.sanitize(marked(val || '', { sanitize: true, renderer, pedantic: false })).replaceAll(/(?<!^)&nbsp;/gm, ' ')

	setTimeout(() => {
		tippy('[title]', {
			theme: 'title',
			placement: 'top',
			maxWidth: '450px',
			delay: [350, 150],
			content(ref) {
				const title = ref.getAttribute('title')
				ref.removeAttribute('title')
				return title
			}
		})
	}, 250)
	return markdown
}
